var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabinetApostolRewardsIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14C1.14333 14.4273 1.31 14.8423 1.5 15.245M3.125 17.746C3.44233 18.1147 3.781 18.4597 4.141 18.781M8 21C7.55475 20.8553 7.1192 20.6822 6.696 20.482",
    stroke: "#FFD700",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5C11.2967 12.5 11.5867 12.412 11.8334 12.2472C12.08 12.0824 12.2723 11.8481 12.3858 11.574C12.4994 11.2999 12.5291 10.9983 12.4712 10.7074C12.4133 10.4164 12.2704 10.1491 12.0607 9.93934C11.8509 9.72956 11.5836 9.5867 11.2926 9.52882C11.0017 9.47094 10.7001 9.50065 10.426 9.61418C10.1519 9.72771 9.91762 9.91997 9.7528 10.1666C9.58797 10.4133 9.5 10.7033 9.5 11M11 12.5C10.6022 12.5 10.2206 12.342 9.93934 12.0607C9.65804 11.7794 9.5 11.3978 9.5 11M11 12.5V15M9.5 11H5",
    stroke: "#FFD700",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C16.523 21 21 16.523 21 11C21 5.477 16.523 1 11 1C5.477 1 1 5.477 1 11",
    stroke: "#FFD700",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabinetApostolRewardsIcon1);
export default __webpack_public_path__ + "static/media/tc_cabinet_apostol_rewards_icon1.e797a99d0eb2918b7b7a73e4ca3fcd31.svg";
export { ForwardRef as ReactComponent };